// React
import React from "react";
import PropTypes from "prop-types";
// Tools
import i18n from "../../../i18n";
import moment from "moment";
// Components
import {Form} from "../../../components";
import * as actions from "../../../store/actions";
import {useDispatch} from "react-redux";
import css from "../../Caretakers/CalendarEdit/EditReminder.module.css";

const EditReminder = props => {
    const dispatch = useDispatch();
    const editForm = {
        message:      {
            label:          i18n.calendarEditFormTitle,
            className:      css.tourMessage,
            type:           "textarea",
            height:         123,
            elementConfig:  {wrap: "soft"},
            disableNewLine: true
        },
        wholeDay:     {
            className:  css.tourWholeDay,
            label:      i18n.calendarEditWholeDay,
            labelValue: [i18n.calendarEditWholeDayYes, i18n.calendarEditWholeDayNo],
            noLabel:    true,
            type:       "switch",
        },
        start:        {
            label:         i18n.calendarEditFormStart + ":",
            classNameDate: css.tourDateStart,
            classNameTime: css.tourTimeStart,
            type:          "datetime",
            defaultValue:  props.newDate ? moment(props.newDate, "YYYY-MM-DD").hours(12).minutes(0) : moment(),
            show:          form => !form.wholeDay.value
        },
        startDay:     {
            className:    css.tourDateStart,
            label:        i18n.calendarEditFormDate,
            type:         "date",
            defaultValue: props.newDate ? moment(props.newDate, "YYYY-MM-DD").hours(12).minutes(0) : moment(),
            show:         form => form.wholeDay.value
        },
        end:          {
            label:         i18n.calendarEditFormEnd + ":",
            classNameDate: css.tourDateEnd,
            classNameTime: css.tourTimeEnd,
            type:          "datetime",
            defaultValue:  props.newDate ? moment(props.newDate, "YYYY-MM-DD").hours(13).minutes(0) : moment().add(1, "hour"),
            show:          form => !form.wholeDay.value
        },
        endDay:       {
            className:    css.tourDateEnd,
            label:        i18n.calendarEditFormEndDate,
            type:         "date",
            defaultValue: props.newDate ? moment(props.newDate, "YYYY-MM-DD").hours(13).minutes(0) : moment().hours(13).minutes(0),
            show:         form => form.wholeDay.value
        },
        notification: {
            label:        i18n.calendarEditFormNotification,
            labelValue:   [i18n.calendarEditFormNotificationYes, i18n.calendarEditFormNotificationNo],
            className:    css.tourNotification,
            noLabel:      true,
            type:         "switch",
            defaultValue: true,
            show:         form => !form.wholeDay.value
        },
        recurring:    {
            label:        i18n.calendarEditFormRecurrence,
            className:    css.tourRecurring,
            defaultValue: "none",
            type:         "select",
            options:      i18n.calendarRecurrences.options
        },
        interval:     {
            label:        i18n.calendarEditFormInterval,
            className:    css.tourRecurringInterval,
            defaultValue: "1 week",
            type:         "select",
            options:      i18n.calendarRecurrences.interval,
            show:         form => form.recurring.value === "interval"
        },
        weekDays:     {
            label:     i18n.calendarEditFormDaysOfWeek,
            noLabel:   true,
            className: css.tourRecurringWeekdays,
            type:      "weekselector",
            show:      form => form.recurring.value === "weekdays"
        }
    };

    const handleChange = (formValues, formValid, itemName) => {
        switch (itemName) {
            case "start":
                formValues = {...formValues, startDay: moment(formValues.start)};
                if (formValues.start.isAfter(formValues.end)) {
                    formValues.end    = moment(formValues.start).add(1, "hours");
                    formValues.endDay = moment(formValues.end);
                }
                break;

            case "startDay":
                formValues = {...formValues, start: moment(formValues.startDay)};
                if (formValues.startDay.isAfter(formValues.endDay)) {
                    formValues.startDay.hours(12, 0, 0);
                    formValues.start  = moment(formValues.startDay);
                    formValues.endDay = moment(formValues.startDay).hours(13);
                    formValues.end    = moment(formValues.endDay);
                }
                break;

            case "end":
                formValues = {...formValues, endDay: moment(formValues.end)};
                if (formValues.end.isBefore(formValues.start)) {
                    formValues.start    = moment(formValues.end).subtract(1, "hours");
                    formValues.startDay = moment(formValues.start);
                    dispatch(actions.messages.infoPush(i18n.calendarStartTimeChanged));
                }
                break;

            case "endDay":
                formValues = {...formValues, end: moment(formValues.endDay)};
                if (formValues.endDay.isBefore(formValues.startDay)) {
                    formValues.endDay.hours(12).minutes(0).seconds(0);
                    formValues.end      = moment(formValues.endDay);
                    formValues.startDay = moment(formValues.endDay).hours(13);
                    formValues.start    = moment(formValues.startDay);
                    dispatch(actions.messages.infoPush(i18n.calendarStartTimeChanged));
                }
                break;

            default:
        }
        props.setValues(formValues, formValid);
    };

    return (
        <Form inlineSelect formData={editForm} values={props.item} onChange={handleChange} onValid={props.setValid}/>
    );
};

EditReminder.propTypes = {
    item:      PropTypes.object,
    group:     PropTypes.object,
    setValues: PropTypes.func.isRequired,
    setValid:  PropTypes.func.isRequired
};

export default EditReminder;
